<div class="chatalert">
    <div class="chatAlertContainer">
        <div class="chatAlertRepImage">
            <img id="rep-image" width="100px" height="112px" class="border-light-grey" [src]="repImage" />
        </div>
        <div id="rep-name-message" class="chatAlertMessage" class="width-58">{{repName}} :
            <br>
            <span matTooltip="{{repMessage}}" class="word-break">{{ (truncateRepMsg)? (repMessage | slice:0:50)+'..':(repMessage) }}</span>
        </div>
        <div class="chatAlertButtons">
            <span>Would you like to chat?</span>
            <br>
            <button id="rep-btn-yes" type="button" class="chatAlertButton" (click)="toggleState('yes')">
                Yes</button>
            <button id="rep-btn-no" type="button" class="chatAlertButton" (click)="toggleState('no')">
                No</button>
        </div>
    </div>
</div>